// index              0   1   2   3   4   5    6
export const space = [0, 15, 30, 45, 60, 90, 120]
